import { IStackTokens } from "@fluentui/react/lib/";
import { IVerticalDividerClassNames } from "@fluentui/react/lib/Divider";
import { ITheme, mergeStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import {
  commonHighContrastNoAdjustStyles,
  getDividerClassNames,
} from "@1js/acui-common";

export const sectionDividerWidth = 17; // 1px + 16px Padding
export const getSectionDividerClassNames = memoizeFunction(
  (theme: ITheme): IVerticalDividerClassNames => {
    return mergeStyleSets(getDividerClassNames(theme), {
      divider: [
        {
          // Shorten the divider so it has 4px above and below
          height: "calc(100% - 8px)",
        },
        "ribbon-vertical-divider",
        commonHighContrastNoAdjustStyles,
      ],
      wrapper: {
        padding: "0 4px",
      },
    });
  }
);

export const rowDividerWidth = 9; // 1px + 8px Padding
export const getRowDividerClassNames = memoizeFunction(
  (theme: ITheme): IVerticalDividerClassNames => {
    return mergeStyleSets(getDividerClassNames(theme), {
      divider: [
        {
          // Shorten the divider so it has 2px above and below
          height: "calc(100% - 4px)",
        },
        commonHighContrastNoAdjustStyles,
        "ribbon-row-divider",
      ],
      wrapper: {
        padding: "0 4px",
      },
    });
  }
);

export const getRowStackTokens = memoizeFunction(
  (rowCount: number): IStackTokens => {
    if (rowCount !== 2) {
      return {};
    }

    return {
      childrenGap: "4px 0px",
      padding: "12px 0px 0px 0px",
    };
  }
);
